<template>
  <div class="navigation">
    <ul class="navigation--items">
      <li>
        <router-link :to="{ name: 'homepage' }"
          ><span @click="$emit('toggle-menu')">Homepage</span></router-link
        >
      </li>
      <li v-if="authentication">
        <router-link @click.native="logout()" :to="{ name: 'homepage' }">Logout</router-link>
      </li>
      <li v-if="!authentication">
        <router-link :to="{ name: 'dc-sso' }">Ho un buono</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { chevron_down_toggler } from '@/components/svg/chevrons';
import { is_authenticated } from '@/utilities';
import { logout } from '@/api';

export default {
  name: 'navigation',
  emits: ['toggle-menu'],
  components: {},
  created() {
    this.chevron_down_toggler = chevron_down_toggler;
    this.is_authenticated = is_authenticated;
    this.logout = logout;
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    authentication: {
      get() {
        return this.is_authenticated();
      },
    },
  },
};
</script>

<style lang="scss">
.navigation {
  &--items {
    display: flex;
    flex-direction: column;
    align-items: center;
    li {
      padding: $grid-gutter-width/2 0;

      @include media-breakpoint-up(lg) {
        padding: $grid-gutter-width/4 $grid-gutter-width/2;
      }
    }
    @include media-breakpoint-up(lg) {
      flex-direction: row;
      li {
        padding: 0 $grid-gutter-width/2;
      }
    }
    a,
    a:hover,
    a:active,
    a:focus,
    a:visited {
      color: $text;
    }
    a:hover {
      color: $cta;
    }
  }
}

#site-header .menu--navigation {
  padding: 0 !important;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  ul {
    list-style: none;
    margin: 0;
    li {
      margin: 0;
    }
  }
}
</style>
